var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWiredHuman(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 225,
    height: 65,
    viewBox: "0 0 225 65",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M214.119 63.9828H212.523V48.0707H212.855L223.404 60.2597V48.0707H225V63.9828H224.645L214.119 51.949V63.9828Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M195.121 48.0707H195.498L202.922 63.9828H201.215L198.711 58.7527H191.841L189.359 63.9828H187.586L195.121 48.0707ZM198.002 57.2014L195.298 51.4393L192.55 57.2014H198.002Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M162.367 63.9828H160.816L163.076 48.0707H163.342L169.813 61.124L176.218 48.0707H176.484L178.744 63.9828H177.193L175.642 52.5917L170.013 63.9828H169.614L163.896 52.5031L162.367 63.9828Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M148.931 58.1765V48.0707H150.527V58.4202C150.527 62.1656 148.51 64.3817 145.252 64.3817C141.994 64.3817 139.978 62.1656 139.978 58.4202V48.0707H141.573V58.1765C141.573 59.4175 141.573 60.5256 142.415 61.5672C143.102 62.4315 144.055 62.8304 145.252 62.8304C146.449 62.8304 147.402 62.4315 148.089 61.5672C148.931 60.5256 148.931 59.4175 148.931 58.1765Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M117.692 63.9828V48.0707H119.287V54.7414H127.398V48.0707H128.994V63.9828H127.398V56.2927H119.287V63.9828H117.692Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8702 63.9828V48.0707H84.7929C86.5436 48.0707 88.1614 48.1594 89.7349 48.8021C92.5938 49.9545 94.3002 52.7025 94.3002 56.2041C94.3002 60.7472 91.5522 63.9828 86.4328 63.9828H80.8702ZM82.4659 62.4315H84.815C87.829 62.4315 89.8236 62.1656 91.2419 60.437C92.1505 59.3289 92.6381 57.8884 92.6381 56.2262C92.6381 54.6084 92.1949 53.1679 91.3084 52.0155C89.8014 50.0431 87.5409 49.6221 84.0837 49.6221H82.4659V62.4315Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9191 63.9828V48.0707H71.0054V49.6221H63.5147V54.6084H71.0054V56.1598H63.5147V62.4315H71.0054V63.9828H61.9191Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4323 63.9828V48.0707H45.0889C46.7511 48.0707 48.0143 48.1815 48.7899 48.4697C50.4299 49.0902 51.405 50.5085 51.405 52.3036C51.405 53.1014 51.2942 53.5668 50.9396 54.276C50.1196 55.9381 48.524 56.5808 45.8868 56.5808L51.6266 63.9828H49.6542L43.9365 56.5808H43.0279V63.9828H41.4323ZM46.2857 49.6221H43.0279V55.0295C43.9144 55.0295 44.823 55.0517 45.6651 55.0517C47.0392 55.0517 48.1029 54.9187 48.7899 54.3647C49.3661 53.8993 49.7429 53.1236 49.7429 52.3036C49.7429 50.7523 48.6791 49.6221 46.2857 49.6221Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0309 63.9828V48.0707H30.6265V63.9828H29.0309Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M4.49882 63.9829L0 48.0708H1.63997L4.87557 59.5284L9.44088 48.0708H9.77331L14.2721 59.5284L17.5742 48.0708H19.192L14.6267 63.9829H14.3165L9.61817 51.9491L4.78693 63.9829H4.49882Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4028_1739)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.261 33.8712L124.055 35.2318H89.5058L106.78 5.52391L120.256 28.7047H122.26L108.367 4.8092H105.198L87.9319 34.4998L89.3584 36.954H124.202L125.629 34.4998L125.264 33.8712H123.261Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.641 0H116.471L112.022 7.65085L113.024 9.37304L118.054 0.719016L135.328 30.4269H100.779L110.019 14.5396L109.018 12.8174L99.2053 29.6949L100.632 32.1491H135.476L136.902 29.6949L119.641 0Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4028_1739"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48.9702,
    height: 36.954,
    fill: "white",
    transform: "translate(87.9319)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWiredHuman);
export default __webpack_public_path__ + "static/media/wired-human.e7c04d09784a7f61a7731edf2b507608.svg";
export { ForwardRef as ReactComponent };